import { $myFetch } from "."

export const $getBrands = (): Promise<any> => {
  const myHeaders = new Headers()
  return $myFetch(
    "brand",
    {
      headers: myHeaders,
    },
    []
  )
}
